import * as d3 from 'd3';

const candlestick = {
  id: 'candlestick',
  label: 'Candlestick',
  getYExtent(data) {
    return [d3.min(data, (d) => d.low), d3.max(data, (d) => d.high)];
  },
  draw({ group, data, xScale, yScale, theme, barWidth }) {
    const wicks = group.selectAll('.mark-wick').data(data, (d) => d.date);
    wicks.exit().remove();
    wicks
      .enter()
      .append('line')
      .attr('class', 'mark-wick')
      .merge(wicks)
      .attr('x1', (d) => xScale(d.date))
      .attr('x2', (d) => xScale(d.date))
      .attr('y1', (d) => yScale(d.high))
      .attr('y2', (d) => yScale(d.low))
      .attr('stroke', (d) => (d.close >= d.open ? theme.bull.strong : theme.bear.strong))
      .attr('stroke-width', 1);

    const bodies = group.selectAll('.mark-body').data(data, (d) => d.date);
    bodies.exit().remove();
    bodies
      .enter()
      .append('rect')
      .attr('class', 'mark-body')
      .merge(bodies)
      .attr('x', (d) => xScale(d.date) - barWidth / 2)
      .attr('y', (d) => yScale(Math.max(d.open, d.close)))
      .attr('width', barWidth)
      .attr('height', (d) => Math.max(1, Math.abs(yScale(d.open) - yScale(d.close))))
      .attr('fill', (d) => (d.close >= d.open ? theme.bull.strong : theme.bear.strong));
  },
  tooltipFields(d) {
    return { open: d.open, high: d.high, low: d.low, close: d.close, volume: d.volume };
  },
};

export default candlestick;
